import { Modal, Box } from '@mui/material'
import { useContext, useState } from 'react'
import CardContainer from '~/components/CardContainer'
import CircleButton from '~/components/CircleButton'
import RootStore from '~/stores/RootStore'
import { observer } from 'mobx-react-lite'

export default observer(() => {
  const store = useContext(RootStore)
  const [currentIndex, setCurrentIndex] = useState(0)
  const { imageUrls, isOpen, closeImageModal } = store.imageModalHandler

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? imageUrls.length - 1 : prev - 1))
  }

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === imageUrls.length - 1 ? 0 : prev + 1))
  }

  return (
    <Modal
      open={isOpen}
      onClose={closeImageModal}
      aria-labelledby='image-modal'
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <>
        <CardContainer
          sx={{
            position: 'relative',
            width: '90vw',
            height: '90vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
            bgcolor: 'background.paper',
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src={imageUrls[currentIndex]}
              alt=''
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
            />
          </Box>

          {currentIndex > 0 && (
            <CircleButton
              onClick={handlePrevious}
              icon8='smExpandArrow'
              sx={{
                position: 'absolute',
                left: 16,
                transform: 'rotate(90deg)',
              }}
            />
          )}

          {currentIndex < imageUrls.length - 1 && (
            <CircleButton
              onClick={handleNext}
              icon8='smExpandArrow'
              sx={{
                position: 'absolute',
                right: 16,
                transform: 'rotate(-90deg)',
              }}
            />
          )}
        </CardContainer>
      </>
    </Modal>
  )
})